/**
 * 语言包名称映射表
 * @description 名称是我们自己项目中定义使用的
 */
export const langModuleNameMap: Record<string, string> = {
  /** 中文(繁體)*/
  tw: '中文(繁體)',
  /** 英文 */
  en: 'English'
}

/**
 * 语言code转换映射表
 */
export const langCodeTransMap: Record<string, string> = {
  /**  英文 */
  'en-US': 'en',
  /**  中文(繁體) */
  'zh-TW': 'tw',
  /**  中文(简体) */
  'zh-CN': 'cn'
}

/**
 * 语言id映射表
 */
export const apiLanguageIdMap: Record<string, number> = {
  cn: 1,
  tw: 2,
  en: 3
}
